import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CashRelief from '@/pages/cash-relief/CashRelief.vue';

export default {
  path: '/accounting-cash/cash-relief/:userId',
  name: 'CashRelief',
  components: {
    mainContent: CashRelief,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'cash-relief',
    },
    breadcrumb: {
      title: 'Controle de Caixa',
      paths: [{ title: 'Sangria' }],
    },
  },
};
